import React from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';

import { moment } from '@eventbrite/date';
import { ISO_8601_DATE_FORMAT } from '@eventbrite/datetime';
import { ValidationFormField } from '@eventbrite/eds-validation-form-field';
import { formValidate } from '@eventbrite/eds-utils';
import { normalizeLocale } from '../../../utils/general';

import { getSeriesCalendar } from '../../../selectors/series';
import {
    getSeriesEvents as getSeriesEventsAction,
    getSeriesEventsByDate as getSeriesEventsByDateAction,
} from '../../../actions/series';
import { trackDatePickerSelectionClear } from '../../../actions/eventAnalytics';
import { EVENT_SERIES_FORM_NAME } from '../../../constants';

import { AccessibleDatePicker } from '@eventbrite/eds-date-picker-accessible';
import { getDefaultLocale } from '../../../selectors/app';

const SeriesEventDatePicker = ({
    calendar = [],
    localeCode,
    onSelectedDate,
    onClearDate,
    onMonthChange,
}) => {
    return calendar.length ? (
        <div
            className="eds-g-cell-sm-12-12 eds-g-cell-md-6-12"
            data-automation="series-events-date-picker"
        >
            <ValidationFormField name="filterDate" v2={true}>
                <AccessibleDatePicker
                    childEvents={calendar}
                    localeCode={localeCode}
                    onClear={onClearDate}
                    onMonthChange={onMonthChange}
                    onSelect={onSelectedDate}
                    name="filterDate"
                />
            </ValidationFormField>
        </div>
    ) : null;
};

const getMonthRange = (date) => {
    const startDate = moment(date).startOf('month');
    const endDate = moment(date).endOf('month');

    return { startDate, endDate };
};

export const SeriesEventDatePickerContainer = connect(
    (state) => ({
        calendar: getSeriesCalendar(state),
        localeCode: normalizeLocale(getDefaultLocale(state)),
    }),
    (dispatch) => ({
        onClearDate: () => {
            dispatch(trackDatePickerSelectionClear());
            dispatch(change(EVENT_SERIES_FORM_NAME, 'filterDate', ''));
        },
        onSelectedDate: (date) => {
            const formattedDate = moment(date).format(ISO_8601_DATE_FORMAT);
            if (!formattedDate) {
                return;
            }
            dispatch(
                getSeriesEventsByDateAction({
                    startDate: formattedDate,
                }),
            );
            dispatch(
                change(EVENT_SERIES_FORM_NAME, 'filterDate', formattedDate),
            );
        },
        onMonthChange: (date) => {
            const { startDate, endDate } = getMonthRange(date);

            dispatch(
                getSeriesEventsAction({
                    startDate,
                    endDate,
                    showLoader: false,
                }),
            );
        },
    }),
)(
    formValidate({
        form: EVENT_SERIES_FORM_NAME,
    })(SeriesEventDatePicker),
);
